import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import appTheme from './createAppTheme';

/**
 * Global theme wrapper (Phase 1) — colors + typography + CssBaseline only.
 * No MUI component styleOverrides; existing screens stay visually unchanged.
 */
function ThemeProvider({ theme = appTheme, children }) {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}

export default ThemeProvider;
